// Shared greys for the Nova Studio shell. These aren't in the design system's token set yet, so
// they're centralised here rather than repeated as inline hexes across the catalogue, header, shell
// and version-history components. Replace with `theme.sys.*` tokens once equivalents exist.
export const NovaStudioColor = {
	// Hairline borders separating the catalogue panel, header and version rows.
	border: '#e6e8f0',
	// Secondary/label text (category names, tab hints, muted metadata).
	textMuted: '#6b7280',
	// Background of the per-category agent-count badge.
	badgeBackground: '#eef0f5',
	// Agent row label — slightly darker when the row is the selected agent.
	agentRowText: '#33334d',
	agentRowTextSelected: '#1a1a2b',
} as const;
